import { Component } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import * as AOS from "aos";
import { PathsDataService } from './services/paths-data.service';
import { ImgsCollection } from './interfaces/images/imgs-collection.interface';
import { footerKey } from './interfaces/images/nav-footer-collection.interface';
import { IconsCollection } from './interfaces/icons/icons-collection.interface';
import { SecurityHeadersService } from './services/security-headers.service';
import { env } from 'src/environments/environments';
declare let $: any;



const DEFAULT_IMAGES: Record<string, string> =  env.DEFAULT_IMAGES;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {

    title = 'Valor más';

    location: any;
    routerSubscription: any;
    imagesHome: Record<string, string> = {};
    logoGov?: string;
    footerImgs?: footerKey;



    constructor(
        public router: Router,
        private pathsDataService: PathsDataService,
        private securityHeadersService: SecurityHeadersService
    ) {
        AOS.init();
    }

    ngOnInit(){
        this.getDomain();
        this.recallJsFuntions();
        this.resquestPathIcns();
        this.defaultPathImg();
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }



    defaultPathImg() {
        this.imagesHome = { ...DEFAULT_IMAGES };
        this.logoGov = this.imagesHome['logo'];
    }


    getDomain() {
        // Obtener el dominio actual
        let fullDomain = `${window.location.protocol}//${window.location.hostname}`;

        if(fullDomain === 'http://localhost') {
            fullDomain = `${fullDomain}:${window.location.port}`;
        }

        sessionStorage.setItem('domain', fullDomain);
    }



    resquestPathIcns() {
        this.pathsDataService.getPathIcons()
        .subscribe({
            next: (data: IconsCollection) => {
                this.footerImgs = data.footer;
            },
            error: (error) => {
            }
        });
    }



}
